export enum SubStrategyType {
    NONE = 'none',
    UNSUPPORTED = 'unsupported',
}
